export const CATEGORY_GROUP_EQUIPMENT = "EQUIPMENT";
export const CATEGORY_GROUP_SPACE = "SPACE";
export const CATEGORY_GROUP_WORKFORCE = "WORKFORCE";
export const CATEGORY_GROUP_OTHER = "OTHER";